export const removeTrailingSlash = (url: string): string => {
  if (!url.endsWith("/")) {
    return url;
  }

  return url.slice(0, url.length - 1);
};

/** Encode a raw path segment or query value, never a composed URL.
 * Empty/reserved IDs and dot segments retain their existing routing limitations.
 * Malformed Unicode throws rather than silently changing the identifier.
 */
export const encodeRouteParam = (value: string | number): string =>
  encodeURIComponent(String(value));

/** Only for raw URL text; Next router params and URLSearchParams are already decoded. */
export const decodeUrlComponent = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};
